import { useEffect, useState } from 'react';

// Global announcer for screen readers
let globalAnnounce = () => {};

export function announce(message, priority = 'polite') {
  globalAnnounce(message, priority);
}

export default function ScreenReaderAnnouncer() {
  const [politeMessage, setPoliteMessage] = useState('');
  const [assertiveMessage, setAssertiveMessage] = useState('');

  useEffect(() => {
    globalAnnounce = (msg, priority) => {
      if (priority === 'assertive') {
        setAssertiveMessage(msg);
        setTimeout(() => setAssertiveMessage(''), 1000);
      } else {
        setPoliteMessage(msg);
        setTimeout(() => setPoliteMessage(''), 1000);
      }
    };
    return () => { globalAnnounce = () => {}; };
  }, []);

  return (
    <>
      <div aria-live="polite" aria-atomic="true" className="sr-only" style={{ position: 'absolute', left: '-10000px', width: '1px', height: '1px', overflow: 'hidden' }}>
        {politeMessage}
      </div>
      <div aria-live="assertive" aria-atomic="true" className="sr-only" style={{ position: 'absolute', left: '-10000px', width: '1px', height: '1px', overflow: 'hidden' }}>
        {assertiveMessage}
      </div>
    </>
  );
}
